import { CustomResponse } from '@/models/custom-response.model';
import { AuthenticationService } from '@/services';
import router from '@/router';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Notification = namespace('notification');

@Component
export default class ResetPasswordView extends Vue {
    @Notification.Action('addSuccess') private addSuccess: any;
    @Notification.Action('addError') private addError: any;

    public credentials: any = {
        password: '',
        passwordRepeat: '',
        token: null,
    };

    public submitted: boolean = false;

    public mounted() {
        if (this.$route.query && this.$route.query.token) {
            this.credentials.token = this.$route.query.token;
        } else {
            this.addError({
                title: 'No query token found.',
                message: 'There is no reset token present. Please try again.',
            });
        }
    }

    public async handleSubmit() {
        this.submitted = true;
        const { password, passwordRepeat, token } = this.credentials;

        if (password && passwordRepeat && token) {
            try {
                const response = await AuthenticationService.resetPassword(password, passwordRepeat, token);
                this.addSuccess(response.localized);
                router.push('/admin/login');
            } catch (error) {
                this.addError(error.localized, error);
            }
        } else {
            this.addError({
                title: 'Missing fields.',
                message: 'Please check your data, there are fields missing.',
            });
        }
    }

}
